var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconAiAssistant(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 32,
    viewBox: "0 0 40 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 40,
    transform: "translate(40) rotate(90)",
    fill: "#82C4FD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.7775 9.77778C21.7775 10.4358 21.42 11.0103 20.8886 11.3177V12.4444H25.9997C27.1043 12.4444 27.9997 13.3399 27.9997 14.4444V16C28.4907 16 28.8886 16.398 28.8886 16.8889V18.6667C28.8886 19.1576 28.4907 19.5556 27.9997 19.5556V22C27.9997 23.1046 27.1043 24 25.9997 24H13.9997C12.8952 24 11.9997 23.1046 11.9997 22V14.4444C11.9997 13.3399 12.8952 12.4444 13.9997 12.4444H19.1108V11.3177C18.5795 11.0103 18.222 10.4358 18.222 9.77778C18.222 8.79594 19.0179 8 19.9997 8C20.9816 8 21.7775 8.79594 21.7775 9.77778ZM11.9997 16C11.5088 16 11.1108 16.398 11.1108 16.8889V18.6667C11.1108 19.1576 11.5088 19.5556 11.9997 19.5556V16ZM16.8886 15.1111C16.1522 15.1111 15.5553 15.7081 15.5553 16.4444C15.5553 17.1808 16.1522 17.7778 16.8886 17.7778C17.625 17.7778 18.2219 17.1808 18.2219 16.4444C18.2219 15.7081 17.625 15.1111 16.8886 15.1111ZM24.4442 16.4444C24.4442 17.1808 23.8472 17.7778 23.1108 17.7778C22.3745 17.7778 21.7775 17.1808 21.7775 16.4444C21.7775 15.7081 22.3745 15.1111 23.1108 15.1111C23.8472 15.1111 24.4442 15.7081 24.4442 16.4444ZM23.5553 19.5556H16.4442V20.3333C16.4442 20.8856 16.8919 21.3333 17.4442 21.3333H22.5553C23.1076 21.3333 23.5553 20.8856 23.5553 20.3333V19.5556Z",
    fill: "#03447D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAiAssistant);
export default __webpack_public_path__ + "static/media/icon-ai-assistant.9d577b0b85d2e288b0c342117929d6ba.svg";
export { ForwardRef as ReactComponent };